import { render } from "./QuoteInfo.vue?vue&type=template&id=980c0642"
import script from "./QuoteInfo.vue?vue&type=script&lang=js"
export * from "./QuoteInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__